module.exports = __webpack_public_path__ + "static/media/number-yellow-5.83386580.png";